import React, { useEffect } from "react";
import { useParams } from "react-router";
import {
  setup,
  getDomainFromSearch,
  getRawDomainFromSearch,
  getPageToRedirect,
} from "./Theme";
import LoaderPR from "./LoaderPR";
import * as Utils from "./Utils";
import { Form, HeaderForm, ContentForm, DescriptionForm } from "./Form";

const DEFAULT_PAGE = "login";
const ALLOWED_PAGES = new Set([DEFAULT_PAGE, "forgot", "updatepassword"]);

function Setup() {
  const { id } = useParams();
  const domain = getDomainFromSearch();
  const rawDomain = getRawDomainFromSearch();
  // getPageToRedirect returns null when the query param is missing or empty
  const requestedPage = getPageToRedirect();
  const pageToRedirect =
    requestedPage !== null && ALLOWED_PAGES.has(requestedPage)
      ? requestedPage
      : DEFAULT_PAGE;
  useEffect(() => {
    setup(id, domain, rawDomain);
    Utils.redirectPage(
      `/${pageToRedirect}?domain=${encodeURIComponent(rawDomain)}`
    );
  }, []);
  return (
    <Form name="loginForm">
      <HeaderForm />
      <ContentForm>
        <DescriptionForm
         title="Login"
         description="Waiting..."
        />
        <LoaderPR showLoading={true} />
      </ContentForm>
    </Form>
  );
}

export default Setup;
